"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selfServicePermissions = void 0;
var enum_1 = require("../enum");
exports.selfServicePermissions = [enum_1.Permissions.CanCreateOwnUserType];
